module.exports = __webpack_public_path__ + "cd455783/img/menu-icon.5f8facae.svg";